export default "__VITE_ASSET__Dzt$bAuF__"